import styled from 'styled-components';

import theme from 'v3/theme';

export const Container = styled.div`
  display: flex;
  text-align: left;
  border-top: 1px solid ${theme.colors.secondary};
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 0;
  padding-right: 0;
  margin: 0px;
  cursor: pointer;
  transition: 0.5s ease;
  background-attachment: #f9f9f9;
  width: 100%;
  &:hover {
    background-color: #f7f7f7;
  }

  .route-column,
  .client-column {
    text-align: left;
    padding-right: 24px;
  }

  .route-line,
  .client-line {
    display: block;
    margin-bottom: 8px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.45;
  }

  .route-line:last-child,
  .client-line:last-child {
    margin-bottom: 0;
  }

  .item-link {
    align-items: flex-start;
  }
`;
